"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterByModels = void 0;
const filterByModels = (...models) => [
    {
        dynamodb: {
            NewImage: {
                _type: {
                    S: models,
                },
            },
        },
    },
    {
        dynamodb: {
            OldImage: {
                _type: {
                    S: models,
                },
            },
        },
    },
];
exports.filterByModels = filterByModels;
